import { AutocompleteModule, DatepickerModule, PaginationMapsModule, SelectModule } from "maps-angular-components";
import {CommonModule, DatePipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TabsModule, TooltipModule} from 'ngx-bootstrap';

import {CarteiraModule} from '../carteira/carteira.module';
import { LogErroComponent } from './log-erro/log-erro.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatDialogModule} from '@angular/material/dialog';
import {MatSelectModule} from '@angular/material/select';
import {NgModule} from '@angular/core';
import {ProcessamentoPesquisaComponent} from './processamento-pesquisa/processamento-pesquisa.component';
import {RegraModule} from '../regra/regra.module';
import {SharedModule} from '../shared/shared.module';
import {_MatMenuDirectivesModule, MatMenuModule} from "@angular/material/menu";
import { CarteiraAutocompleteModule } from "../shared/components/carteira-autocomplete/carteira-autocomplete.module";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { ProcessamentoPeriodoModalComponent } from "./processamento-periodo-modal/processamento-periodo-modal.component";
import { MatDividerModule } from "@angular/material/divider";
import { ProcessamentoPeriodoSelecionadasTableComponent } from "./processamento-periodo-selecionadas-table/processamento-periodo-selecionadas-table.component";
import { MatChipsModule } from "@angular/material/chips";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatCardModule } from "@angular/material/card";

@NgModule({
  imports: [
    CommonModule,
    TabsModule,
    ReactiveFormsModule,
    CarteiraModule,
    RegraModule,
    SharedModule,
    DatepickerModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonModule,
    PaginationMapsModule,
    FormsModule,
    TooltipModule,
    AutocompleteModule,
    CarteiraAutocompleteModule,
    SelectModule,
    MatDialogModule,
    _MatMenuDirectivesModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatChipsModule,
    MatTableModule,
    MatPaginatorModule,
    MatCardModule
  ],
  declarations: [ProcessamentoPesquisaComponent, LogErroComponent, ProcessamentoPeriodoModalComponent, ProcessamentoPeriodoSelecionadasTableComponent],
  providers: [DatePipe],
})
export class ProcessamentoModule {
}
